import { ReportsMetadata, RecordsType } from '../../shared/types/shared.types';

export interface FeaturePlaybookReportInterface {
  document_metadata?: ReportsMetadata;
  features?: RecordsType[];
}

export const FeaturePlaybookColumns = [
  { attribute: 'release', title: 'Release', sortable: true },
  { attribute: 'technology', title: 'Technology', sortable: true },
  { attribute: 'feature_name', title: 'Feature Name', sortable: true },
  { attribute: 'enhancement_and_benefit', title: 'Enhancement & Benefit', sortable: true },
  { attribute: 'faj_number', title: 'FAJ Number', sortable: true },
  { attribute: 'cxc', title: 'CXC', sortable: true },
  { attribute: 'value_package', title: 'Value Package', sortable: true },
  { attribute: 'vp_faj', title: 'VP FAJ', sortable: true },
  { attribute: 'ran_compute_group', title: 'Ran Computer Group', sortable: true },
  { attribute: 'cm_impact', title: 'CM Impact', sortable: true },
  { attribute: 'new_alarms', title: 'New Alarms', sortable: true },
  { attribute: 'kpi_deviations', title: 'KPI Deviations', sortable: true }
];

export const FeaturePlaybookFilters = [
  { attribute: 'search', name: 'search', title: 'Global Search', label: 'Search all columns', type: 'input' },
  { attribute: 'release', name: 'fromRelease', title: 'From Release', label: 'Earliest', type: 'select' },
  { attribute: 'release', name: 'toRelease', title: 'To Release', label: 'Latest', type: 'select' },
  { attribute: 'technology', name: 'technology', title: 'Technology', label: 'All', type: 'select' },
  { attribute: 'impact_type', name: 'impactType', title: 'Impact Type', label: 'All', type: 'select' },
  { attribute: 'impact_at_upgrade', name: 'impactAtUpgrade', title: 'Impact at Upgrade', label: 'All', type: 'select' },
  { attribute: 'cm_impact', name: 'hasCmImpact', title: 'CM Impact', label: 'All', type: 'select' },
  { attribute: 'new_alarms', name: 'hasNewAlarms', title: 'New Alarms', label: 'All', type: 'select' },
  { attribute: 'kpi_deviations', name: 'hasKpiDeviations', title: 'KPI Deviations', label: 'All', type: 'select' }
];

export const FeaturePlaybookDialogMetadata = [
  { attribute: 'metadata.feature_name', title: 'Feature Name' },
  { attribute: 'faj_number', title: 'FAJ Number' },
  { attribute: 'value_package', title: 'Value Package' },
  { attribute: 'vp_faj', title: 'VP FAJ' },
  { attribute: 'technology', title: 'Technology' },
  { attribute: 'impact_at_upgrade', title: 'Impact at Upgrade' }
];

export const FeaturePlaybookDialogImpactAssessment = [
  { attribute: 'impact_type', title: 'Impact Type' },
  { attribute: 'faj_number', title: 'FAJ Number' },
  { attribute: 'cxc', title: 'CXC' }
];
